import { Injectable } from '@angular/core';
import {
    OrganisationIdentifierDto,
    PersonDto
} from '@flyfreely-portal-ui/flyfreely';
import { MODAL_OPTIONS } from '@flyfreely-portal-ui/ngx-bootstrap-customisation';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UpdateAirServicesDialogueComponent } from './air-services/update-air-services-dialogue.component';

@Injectable()
export class ProfileDialoguesService {
    constructor(private modalService: BsModalService) {}

    showAirServicesDialogue(
        profile: PersonDto,
        userAsaIdentifiers: OrganisationIdentifierDto
    ) {
        return this.modalService.show(UpdateAirServicesDialogueComponent, {
            ...MODAL_OPTIONS,
            class: 'modal-md',
            initialState: {
                profile: profile,
                userAsaIdentifiers: userAsaIdentifiers
            }
        });
    }
}
